/* Risewell Yoga Theme JS v2.0 — Shopify AJAX Cart + Full Integration */
(function(){
'use strict';

/* COUNTDOWN */
var ctel=document.getElementById('countdown');
if(ctel){var total=23*3600+47*60+12;setInterval(function(){if(total<=0)total=24*3600;total--;var h=String(Math.floor(total/3600)).padStart(2,'0'),m=String(Math.floor(total%3600/60)).padStart(2,'0'),s=String(total%60).padStart(2,'0');ctel.textContent=h+':'+m+':'+s;},1000);}

/* LIVE COUNTER */
var lc=document.getElementById('liveCount');
if(lc){var b=parseInt((lc.textContent||'1247').replace(/,/g,''))||1247;setInterval(function(){b+=Math.random()>.5?1:-1;if(b<1230)b=1230;if(b>1285)b=1285;lc.textContent=b.toLocaleString();},4500);}

/* FAQ */
window.toggleFaq=function(btn){var item=btn.closest('.faq-item'),isOpen=item.classList.contains('open');document.querySelectorAll('.faq-item.open').forEach(function(i){i.classList.remove('open');});if(!isOpen)item.classList.add('open');};

/* TOAST */
window.showToast=function(msg,type){var t=document.getElementById('toast');if(!t)return;document.getElementById('toastMsg').textContent=msg;t.style.background=type==='error'?'#C0392B':'var(--charcoal)';t.classList.add('show');setTimeout(function(){t.classList.remove('show');},3500);};

/* FORMAT MONEY */
function formatMoney(cents){return '$'+(cents/100).toFixed(2);}

/* RENDER CART ITEMS */
function renderCartItems(items){
  var c=document.getElementById('cartItems');
  if(!c)return;
  if(!items||!items.length){c.innerHTML='<p style="color:var(--mid);font-size:.88rem;text-align:center;padding:2rem 0">Your bag is empty</p>';return;}
  c.innerHTML=items.map(function(item){
    return '<div class="cart-item">'
      +'<div class="ci-img">'+(item.image?'<img src="'+item.image+'" alt="'+item.product_title+'" style="width:100%;height:100%;object-fit:cover">':'&#x1F6CD;')+'</div>'
      +'<div class="ci-info">'
        +'<div class="ci-name">'+item.product_title+'</div>'
        +(item.variant_title&&item.variant_title!=='Default Title'?'<div class="ci-variant">'+item.variant_title+'</div>':'')
        +'<div class="ci-variant">Qty: <button onclick="updateCartQty(\''+item.key+'\','+(item.quantity-1)+')" style="background:none;border:1px solid rgba(201,168,76,.3);border-radius:50%;width:18px;height:18px;cursor:pointer;font-size:11px;line-height:1">-</button> '+item.quantity+' <button onclick="updateCartQty(\''+item.key+'\','+(item.quantity+1)+')" style="background:none;border:1px solid rgba(201,168,76,.3);border-radius:50%;width:18px;height:18px;cursor:pointer;font-size:11px;line-height:1">+</button></div>'
        +'<div class="ci-price">'+formatMoney(item.final_line_price)+'</div>'
      +'</div>'
      +'<button class="ci-remove" onclick="removeFromCart(\''+item.key+'\')" aria-label="Remove">&times;</button>'
    +'</div>';
  }).join('');
}

/* UPDATE CART UI */
function updateCartUI(cart){
  var badge=document.getElementById('cartCount');
  if(badge)badge.textContent=cart.item_count||0;
  var total=document.getElementById('cartTotal');
  if(total)total.textContent=formatMoney(cart.total_price||0);
  renderCartItems(cart.items||[]);
}

/* FETCH CART FROM SHOPIFY */
function fetchCart(){
  fetch('/cart.js',{headers:{'Content-Type':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(cart){updateCartUI(cart);})
    .catch(function(){});
}

/* ADD TO CART VIA SHOPIFY AJAX API */
window.addToCartAjax=function(variantId,qty,btn){
  if(!variantId){showToast('Please select an option','error');return;}
  var origText=btn?btn.textContent:'';
  if(btn){btn.textContent='Adding...';btn.disabled=true;}
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:parseInt(variantId),quantity:qty||1})
  })
  .then(function(r){if(!r.ok)return r.json().then(function(e){throw new Error(e.description||'Could not add to cart');});return r.json();})
  .then(function(item){fetchCart();showToast(item.product_title+' added to your bag!');openCart();})
  .catch(function(err){showToast(err.message||'Error adding to cart','error');})
  .finally(function(){if(btn){btn.textContent=origText;btn.disabled=false;}});
};

/* REMOVE FROM CART */
window.removeFromCart=function(key){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
    .then(function(r){return r.json();}).then(function(cart){updateCartUI(cart);showToast('Item removed');}).catch(function(){});
};

/* UPDATE QUANTITY */
window.updateCartQty=function(key,qty){
  if(qty<0)return;
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(r){return r.json();}).then(function(cart){updateCartUI(cart);}).catch(function(){});
};

/* CART DRAWER */
window.openCart=function(){var d=document.getElementById('cartDrawer'),o=document.getElementById('cartOverlay');if(d)d.classList.add('open');if(o)o.classList.add('open');fetchCart();};
window.toggleCart=function(){var d=document.getElementById('cartDrawer'),o=document.getElementById('cartOverlay');if(d)d.classList.toggle('open');if(o)o.classList.toggle('open');fetchCart();};
window.closeCart=function(){var d=document.getElementById('cartDrawer'),o=document.getElementById('cartOverlay');if(d)d.classList.remove('open');if(o)o.classList.remove('open');};

/* CHECKOUT — native Shopify checkout */
window.goToCheckout=function(){window.location.href='/checkout';};

/* INTERCEPT ALL PRODUCT FORMS FOR AJAX */
function initProductForms(){
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('[type="submit"]');
      var origText=btn?btn.textContent:'';
      if(btn){btn.textContent='Adding...';btn.disabled=true;}
      var fd=new FormData(form);
      fetch('/cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:fd})
        .then(function(r){if(!r.ok)return r.json().then(function(e){throw new Error(e.description||'Error');});return r.json();})
        .then(function(item){fetchCart();showToast(item.product_title+' added to your bag!');openCart();})
        .catch(function(err){showToast(err.message,'error');})
        .finally(function(){if(btn){btn.textContent=origText;btn.disabled=false;}});
    });
  });
}

/* VARIANT RADIO BUTTONS */
function initVariants(){
  document.querySelectorAll('.variant-radio').forEach(function(radio){
    radio.addEventListener('change',function(){
      var form=this.closest('form');if(!form)return;
      var hidden=form.querySelector('input[name="id"]');if(hidden)hidden.value=this.value;
      var btn=form.querySelector('[type="submit"]');
      if(btn){
        if(this.dataset.available==='false'){btn.textContent='Sold Out';btn.disabled=true;}
        else{btn.disabled=false;btn.textContent=btn.dataset.origText||origText;}
      }
      /* update price */
      var pd=form.querySelector('.product-price-display');
      if(pd&&this.dataset.price){
        var cp=parseInt(this.dataset.comparePrice||0),pp=parseInt(this.dataset.price||0);
        pd.innerHTML=(cp>pp?'<span style="text-decoration:line-through;color:var(--mid);font-size:1.4rem;margin-right:4px">'+formatMoney(cp)+'</span>':'')+formatMoney(pp);
      }
      /* update label */
      document.querySelectorAll('.variant-radio[name="'+this.name+'"]').forEach(function(r){
        var lbl=r.closest('.variant-option');
        if(lbl)lbl.classList.toggle('selected',r.checked);
      });
    });
  });
}

/* SHOP FILTERS */
window.filterShop=function(cat,btn){
  document.querySelectorAll('.filter-btn').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
  document.querySelectorAll('[data-cat]').forEach(function(c){c.style.display=(cat==='all'||c.dataset.cat===cat)?'':'none';});
};
window.filterDigital=function(cat,btn){
  document.querySelectorAll('.dtab').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
  document.querySelectorAll('[data-dcat]').forEach(function(c){c.style.display=(cat==='all'||(c.dataset.dcat||'').includes(cat))?'':'none';});
};

/* EXIT POPUP */
var exitShown=false;
document.addEventListener('mouseleave',function(e){if(e.clientY<10&&!exitShown&&window.innerWidth>768){exitShown=true;var ov=document.getElementById('exitOverlay');if(ov)setTimeout(function(){ov.classList.add('show');},500);}});
window.closeExit=function(){var ov=document.getElementById('exitOverlay');if(ov)ov.classList.remove('show');};

/* WISHLIST */
document.querySelectorAll('.wishlist-btn').forEach(function(btn){
  btn.addEventListener('click',function(e){e.stopPropagation();e.preventDefault();var s=this.dataset.saved==='true';this.dataset.saved=s?'false':'true';this.innerHTML=s?'&#9825;':'&#9829;';this.style.color=s?'':'#B8860B';showToast(s?'Removed from wishlist':'Saved!');});
});

/* SMOOTH SCROLL */
document.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var t=document.querySelector(this.getAttribute('href'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}});});

/* INIT */
fetchCart();
initProductForms();
initVariants();

})();
